module.exports = __webpack_public_path__ + "img/20201106_091420.5ac8ec87.jpg";